// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"223ffe7b","453":"38a806a5","568":"144a3f95","732":"c65d1625","977":"85b68541"}[chunkId] + ".chunk.js";
};